Backbone.Radio.channel('views').reply('form-currentmember',function(options){
	var opts = {
		
	}
	
	//var radio = Backbone.Radio.channel('pledgeform')
	
	var view = Marionette.View.extend({
		 template:_.template($("#tmpl-form-currentmember").html())
		,onAttach:function(){
			
		}
	})
	
	
	return new (view)();
});